@if(hasCard || !initialized){
<div class="welcome">
  <div class="row">
    <div class="column" style="padding: 5%">
      <h2>Loading...</h2>
      <mat-spinner [diameter]="150"></mat-spinner>
    </div>
  </div>
</div>
} @if(!hasCard && initialized){
<section class="d-md-flex flex-md-column align-items-lg-center signInPage">
  <div
    class="notification container notificationWidth"
    [innerHtml]="notificationText"
  ></div>
  <div class="d-flex flex-column gap-48-63md">
    <!-- Large screen -->
    <div
      class="d-none d-lg-flex justify-content-center mastheadWidth"
      [ngStyle]="{'background-image': 'url(' + header + ')', 'background-repeat': 'no-repeat','background-size': 'cover'}"
    >
      <div class="container masterhead row m-0 d-flex">
        <div class="col-lg"></div>
        <div class="col-lg card rounded-3 masterhead-card">
          <div class="d-flex flex-column gap-20-18md">
            <div class="d-flex flex-column gap-12-8md">
              <div
                class="gb-headline3 heavy"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.title)"
              ></div>
              <div
                class="gb-body2"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.subTitle)"
              ></div>
            </div>
            <div
              class="flex-column flex-md-row d-flex justify-content-center align-items-center gap-3"
            >
              <button
                (click)="login()"
                type="button"
                class="gb-primary-button primary-button stat-button-link"
                data-dtm="sign in"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.ctaButton)"
              ></button>
              <button
                type="button"
                class="gb-secondary-button secondary-button stat-button-link"
                data-dtm="sign in"
                (click)="createAccount()"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.ctaButton2)"
              ></button>
            </div>
            @if(errorNotice){
            <div class="text-danger">*{{errorNotice}}</div>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- small screen -->
    <div
      class="d-flex d-lg-none justify-content-center"
      [ngStyle]="{'background-image': 'url(' + mobileHeader + ')', 'background-repeat': 'no-repeat','background-size': 'cover'}"
    >
      <div class="container masterhead row m-0 d-flex">
        <div class="col-lg mastheadHeight"></div>
        <div class="col-lg card rounded-3 masterhead-card">
          <div class="d-flex flex-column gap-3">
            <div class="d-flex flex-column gap-12">
              <div
                class="gb-headline3 heavy"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.title)"
              ></div>
              <div
                class="gb-body2"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.subTitle)"
              ></div>
            </div>
            <div
              class="flex-column flex-md-row d-flex justify-content-center align-items-center gap-3"
            >
              <button
                (click)="login()"
                type="button"
                class="gb-primary-button primary-button col-9 col-xs-8 col-sm-6"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.ctaButton)"
              ></button>
              <button
                (click)="createAccount()"
                type="button"
                class="gb-secondary-button secondary-button col-9 col-xs-8 col-sm-6"
                [innerHtml]="$safeNavigationMigration(signOnPage?.masterHead.ctaButton2)"
              ></button>
            </div>
            @if(errorNotice){
            <div class="text-danger">*{{errorNotice}}</div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="container py-0 p-md-0">
      <div class="cardApplication">
        <div
          class="row align-items-center justify-content-center d-flex gap-24-0md mx-1 mx-md-0"
        >
          <div class="col-8 col-md-1">
            <img [src]="card" alt="Card Image" class="img-fluid" />
          </div>
          <div
            class="col-md text-start d-flex flex-column gap-3 ps-md-0 pe-md-3 px-3"
          >
            <div
              class="gb-body1 text-center text-md-start apply-body"
              [innerHtml]="signOnPage?.marketingPage.cardBanner.cardBody"
            ></div>
          </div>
          <button
            class="col-8 col-md-2 gb-secondary-button secondary-button align-self-center"
          >
            <span
              class="pe-2"
              (click)="goToBarclaysSite()"
              [innerHtml]="signOnPage?.marketingPage.cardBanner.cardCta"
            ></span>
            <svg
              class="svg-style"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.2885 10.4058V14.7021C14.2885 15.4178 13.7062 16 12.9905 16H1.296C0.58027 16 -0.00195312 15.4178 -0.00195312 14.7021V3.00568C-0.00195312 2.28995 0.58027 1.70773 1.296 1.70773H5.62373C6.03351 1.70773 6.36541 2.03963 6.36541 2.44941C6.36541 2.8592 6.03351 3.1911 5.62373 3.1911H1.48142V14.5148H12.8051V10.404C12.8051 9.99421 13.137 9.6623 13.5468 9.6623C13.9566 9.6623 14.2885 9.99421 14.2885 10.404V10.4058ZM15.9888 0.608182C15.9869 0.595202 15.9832 0.582223 15.9795 0.569243C15.9721 0.537722 15.9628 0.508054 15.9517 0.478387C15.9461 0.465407 15.9424 0.454282 15.9369 0.441303C15.9202 0.402364 15.8998 0.363426 15.8757 0.328196C15.8757 0.328196 15.872 0.324487 15.8701 0.322633C15.8479 0.289257 15.82 0.257736 15.7922 0.228068C15.783 0.218797 15.7755 0.21138 15.7663 0.202109C15.7422 0.179859 15.7181 0.159462 15.6921 0.14092C15.681 0.133503 15.6717 0.126086 15.6606 0.11867C15.6291 0.0982733 15.5957 0.0797311 15.5623 0.0648974C15.5567 0.0630432 15.5512 0.0593348 15.5456 0.0574806H15.5438C15.503 0.0389385 15.4622 0.0278132 15.4214 0.0185421C15.4103 0.0166879 15.3991 0.0148337 15.388 0.0129795C15.3528 0.00741685 15.3176 0.00370842 15.2805 0.00185421C15.2731 0.00185421 15.2675 0 15.2601 0H9.49347C9.08369 0 8.75178 0.331904 8.75178 0.741685C8.75178 1.15147 9.08369 1.48337 9.49347 1.48337H13.4689L6.25045 8.70182C5.96119 8.99108 5.96119 9.46019 6.25045 9.7513C6.39508 9.89593 6.58421 9.96825 6.77519 9.96825C6.96618 9.96825 7.15531 9.89593 7.29994 9.7513L14.5184 2.53285V6.52497C14.5184 6.93475 14.8503 7.26666 15.2601 7.26666C15.6699 7.26666 16.0018 6.93475 16.0018 6.52497V0.741685C16.0018 0.69533 15.9962 0.650829 15.9888 0.608182Z"
                fill="#3D3935"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex container mobile-padding p-md-0">
      <div class="d-flex flex-column gap-24-48md">
        <div class="d-flex flex-column gap-24-48md">
          <div class="d-flex flex-column text-center gap-3">
            <div
              class="gb-headline1 heavy pageLevelTitle text-white"
              [innerHtml]="signOnPage?.marketingPage.pageContent.pageTitle"
            ></div>
            <div
              class="gb-headline5 text-white"
              [innerHtml]="signOnPage?.marketingPage.pageContent.pageBody"
            ></div>
          </div>
          <div class="row d-flex justify-content-center pt-24 gap-48-24md">
            <div
              class="col-md-auto flex-column d-flex align-items-center gap-24"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="48"
                viewBox="0 0 76 48"
                fill="none"
              >
                <path
                  d="M9.68087 48C9.68087 42.88 10.0972 38.1371 10.9297 33.7714C11.7623 29.3829 12.9999 25.2686 14.6426 21.4286C16.3077 17.5657 18.3892 13.8743 20.8869 10.3543H0.5V0H33.5106V8.43429C31.1704 11.0629 29.1565 14.1257 27.4688 17.6229C25.7811 21.12 24.3973 24.7429 23.3172 28.4914C22.2596 32.2171 21.472 35.7829 20.9544 39.1886C20.4594 42.5943 20.2119 45.5314 20.2119 48H9.68087Z"
                  fill="white"
                />
                <path
                  d="M37.2239 48L50.4551 29.8971L38.034 12.96H49.8476L54.168 18.8571C54.5505 19.36 54.9556 19.92 55.3831 20.5371C55.8331 21.1543 56.1482 21.6914 56.3282 22.1486C56.5757 21.6914 56.8907 21.1543 57.2733 20.5371C57.6783 19.8971 58.0609 19.3371 58.4209 18.8571L62.8763 12.96H74.6899L62.2687 29.8971L75.5 48H63.6864L58.4209 41.0057C58.0609 40.5257 57.6783 39.9657 57.2733 39.3257C56.8907 38.6857 56.5757 38.1486 56.3282 37.7143C56.1482 38.1486 55.8219 38.6857 55.3494 39.3257C54.8993 39.9657 54.5055 40.5143 54.168 40.9714L49.0375 48H37.2239Z"
                  fill="white"
                />
              </svg>
              <div
                class="gb-headline4 text-white"
                [innerHtml]="signOnPage?.marketingPage.pageContent.points[0].text"
              ></div>
            </div>
            <div
              class="col-md-auto flex-column d-flex align-items-center gap-24"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="48"
                viewBox="0 0 76 48"
                fill="none"
              >
                <path
                  d="M17.2699 47.9984C13.2652 47.9984 9.79753 47.0308 6.8705 45.0938C3.94346 43.1567 1.81996 40.4721 0.5 37.0398L9.47873 33.4081C11.4158 36.7975 14.011 38.4922 17.2699 38.4922C19.0298 38.4922 20.4393 38.0522 21.4945 37.1722C22.5516 36.2923 23.0792 35.0599 23.0792 33.4752C23.0792 32.2429 22.5516 31.1635 21.4945 30.2406C20.4374 29.3159 18.9198 28.8536 16.9399 28.8536H11.9229V19.215H16.9399C18.3922 19.215 19.5369 18.7862 20.374 17.9267C21.2092 17.0691 21.6287 15.8704 21.6287 14.3286C21.6287 13.0086 21.1999 11.9087 20.3405 11.0268C19.4828 10.1469 18.3046 9.7069 16.8094 9.7069C14.3876 9.7069 12.4281 10.9187 10.9329 13.3386L1.9542 9.83927C3.44941 6.84702 5.48714 4.49237 8.06182 2.77532C10.6365 1.05828 13.5971 0.200684 16.9417 0.200684C21.2987 0.200684 24.8205 1.43301 27.5052 3.89765C30.1898 6.36229 31.5322 9.55403 31.5322 13.471C31.5322 17.9174 29.7275 21.3273 26.1181 23.7043C28.0551 24.4538 29.6827 25.7961 31.0027 27.7312C32.3226 29.6683 32.9845 32.0453 32.9845 34.8623C32.9845 38.6488 31.5322 41.7846 28.6275 44.2697C25.7228 46.7567 21.9363 48.0002 17.2717 48.0002L17.2699 47.9984Z"
                  fill="white"
                />
                <path
                  d="M38.7909 47.2057L51.599 29.776L39.6485 13.4688H50.8067L55.0313 19.3451C56.3065 21.105 57.0113 22.1397 57.1436 22.4474C57.8036 21.215 58.4636 20.1803 59.1236 19.3451L63.5477 13.4688H74.7058L62.7553 29.776L75.4982 47.2057H64.34L59.1236 40.2741C58.4188 39.3494 57.7589 38.2942 57.1436 37.1047C57.0989 37.2371 56.3942 38.2923 55.0313 40.2741L49.9472 47.2057H38.7909Z"
                  fill="white"
                />
              </svg>
              <div
                class="gb-headline4 text-white"
                [innerHtml]="signOnPage?.marketingPage.pageContent.points[1].text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Earn Section Large Screen size-->
    <div
      class="d-none d-lg-flex justify-content-center earnImage"
      [ngStyle]="{'background-image': 'url('+ gmbCard +')', 'background-repeat': 'no-repeat','background-size': 'cover'}"
    >
      <div class="h-100 d-flex text-wrap container">
        <div class="col"></div>
        <div class="col justify-content-center d-flex flex-column gap-4">
          <div class="gap-1 d-flex flex-column">
            <div
              class="earn-title text-start"
              [innerHtml]="signOnPage?.marketingPage.earnCard.earnTitle"
            ></div>
            <div
              class="earn-subtitle text-start"
              [innerHtml]="signOnPage?.marketingPage.earnCard.earnSubTitle"
            ></div>
          </div>
          <div
            class="earn-body text-wrap text-start"
            [innerHtml]="signOnPage?.marketingPage.earnCard.earnBody"
          ></div>
          <div class="me-auto">
            <button class="gb-secondary-button tertiary-button text-white">
              <span
                class="pe-2"
                (click)="goToBarclaysSite()"
                [innerHtml]="signOnPage?.marketingPage.earnCard.earnCta"
              ></span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M14.2885 10.4058V14.7021C14.2885 15.4178 13.7062 16 12.9905 16H1.296C0.58027 16 -0.00195312 15.4178 -0.00195312 14.7021V3.00568C-0.00195312 2.28995 0.58027 1.70773 1.296 1.70773H5.62373C6.03351 1.70773 6.36541 2.03963 6.36541 2.44941C6.36541 2.8592 6.03351 3.1911 5.62373 3.1911H1.48142V14.5148H12.8051V10.404C12.8051 9.99421 13.137 9.6623 13.5468 9.6623C13.9566 9.6623 14.2885 9.99421 14.2885 10.404V10.4058ZM15.9888 0.608182C15.9869 0.595202 15.9832 0.582223 15.9795 0.569243C15.9721 0.537722 15.9628 0.508054 15.9517 0.478387C15.9461 0.465407 15.9424 0.454282 15.9369 0.441303C15.9202 0.402364 15.8998 0.363426 15.8757 0.328196C15.8757 0.328196 15.872 0.324487 15.8701 0.322633C15.8479 0.289257 15.82 0.257736 15.7922 0.228068C15.783 0.218797 15.7755 0.21138 15.7663 0.202109C15.7422 0.179859 15.7181 0.159462 15.6921 0.14092C15.681 0.133503 15.6717 0.126086 15.6606 0.11867C15.6291 0.0982733 15.5957 0.0797311 15.5623 0.0648974C15.5567 0.0630432 15.5512 0.0593348 15.5456 0.0574806H15.5438C15.503 0.0389385 15.4622 0.0278132 15.4214 0.0185421C15.4103 0.0166879 15.3991 0.0148337 15.388 0.0129795C15.3528 0.00741685 15.3176 0.00370842 15.2805 0.00185421C15.2731 0.00185421 15.2675 0 15.2601 0H9.49347C9.08369 0 8.75178 0.331904 8.75178 0.741685C8.75178 1.15147 9.08369 1.48337 9.49347 1.48337H13.4689L6.25045 8.70182C5.96119 8.99108 5.96119 9.46019 6.25045 9.7513C6.39508 9.89593 6.58421 9.96825 6.77519 9.96825C6.96618 9.96825 7.15531 9.89593 7.29994 9.7513L14.5184 2.53285V6.52497C14.5184 6.93475 14.8503 7.26666 15.2601 7.26666C15.6699 7.26666 16.0018 6.93475 16.0018 6.52497V0.741685C16.0018 0.69533 15.9962 0.650829 15.9888 0.608182Z"
                  fill="#ffffff"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Earn Section Large Screen size end-->
    <!-- Earn Section Small Screen size-->
    <div class="d-flex d-lg-none flex-column justify-content-center">
      <img [src]="gmbCardMobile" class="img-fluid w-100" />
      <div class="d-flex flex-column container gap-0 gap-3-lg">
        <div
          class="earn-title-m text-center"
          [innerHtml]="signOnPage?.marketingPage.earnCard.earnTitle"
        ></div>
        <div
          class="earn-subtitle-m text-center pt-1"
          [innerHtml]="signOnPage?.marketingPage.earnCard.earnSubTitle"
        ></div>
        <div
          class="earn-body-m text-wrap text-center pt-3"
          [innerHtml]="signOnPage?.marketingPage.earnCard.earnBody"
        ></div>
        <div class="m-auto pt-4">
          <button class="gb-secondary-button tertiary-button text-white">
            <span
              class="pe-2"
              (click)="goToBarclaysSite()"
              [innerHtml]="signOnPage?.marketingPage.earnCard.earnCta"
            ></span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M14.2885 10.4058V14.7021C14.2885 15.4178 13.7062 16 12.9905 16H1.296C0.58027 16 -0.00195312 15.4178 -0.00195312 14.7021V3.00568C-0.00195312 2.28995 0.58027 1.70773 1.296 1.70773H5.62373C6.03351 1.70773 6.36541 2.03963 6.36541 2.44941C6.36541 2.8592 6.03351 3.1911 5.62373 3.1911H1.48142V14.5148H12.8051V10.404C12.8051 9.99421 13.137 9.6623 13.5468 9.6623C13.9566 9.6623 14.2885 9.99421 14.2885 10.404V10.4058ZM15.9888 0.608182C15.9869 0.595202 15.9832 0.582223 15.9795 0.569243C15.9721 0.537722 15.9628 0.508054 15.9517 0.478387C15.9461 0.465407 15.9424 0.454282 15.9369 0.441303C15.9202 0.402364 15.8998 0.363426 15.8757 0.328196C15.8757 0.328196 15.872 0.324487 15.8701 0.322633C15.8479 0.289257 15.82 0.257736 15.7922 0.228068C15.783 0.218797 15.7755 0.21138 15.7663 0.202109C15.7422 0.179859 15.7181 0.159462 15.6921 0.14092C15.681 0.133503 15.6717 0.126086 15.6606 0.11867C15.6291 0.0982733 15.5957 0.0797311 15.5623 0.0648974C15.5567 0.0630432 15.5512 0.0593348 15.5456 0.0574806H15.5438C15.503 0.0389385 15.4622 0.0278132 15.4214 0.0185421C15.4103 0.0166879 15.3991 0.0148337 15.388 0.0129795C15.3528 0.00741685 15.3176 0.00370842 15.2805 0.00185421C15.2731 0.00185421 15.2675 0 15.2601 0H9.49347C9.08369 0 8.75178 0.331904 8.75178 0.741685C8.75178 1.15147 9.08369 1.48337 9.49347 1.48337H13.4689L6.25045 8.70182C5.96119 8.99108 5.96119 9.46019 6.25045 9.7513C6.39508 9.89593 6.58421 9.96825 6.77519 9.96825C6.96618 9.96825 7.15531 9.89593 7.29994 9.7513L14.5184 2.53285V6.52497C14.5184 6.93475 14.8503 7.26666 15.2601 7.26666C15.6699 7.26666 16.0018 6.93475 16.0018 6.52497V0.741685C16.0018 0.69533 15.9962 0.650829 15.9888 0.608182Z"
                fill="#ffffff"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- Earn Section Small Screen size end-->
    <section>
      <div class="container">
        <div class="d-flex flex-column text-center mb-24-36md gap-18">
          <div
            class="gb-headline1 heavy pageLevelTitle text-white"
            [innerHtml]="signOnPage?.marketingPage.offersContent.offersTitle"
          ></div>
          <div
            class="gb-headline5 text-white"
            [innerHtml]="signOnPage?.marketingPage.offersContent.offersBody"
          ></div>
        </div>
        <div class="d-flex flex-column position-relative">
          <!-- Redeem Carousel -->
          <div
            class="d-flex align-items-center position-relative w-100 mr-minus-30"
          >
            <button
              class="arrow left z-1 d-none d-md-flex"
              (click)="scrollLeft()"
              [disabled]="currentPage === 0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30px"
                viewBox="0 0 320 512"
                transform="scale(-1 1)"
              >
                <path
                  fill="#ffffff"
                  d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                />
              </svg>
            </button>

            <div
              class="carousel mr-minus-30"
              #carousel
              (scroll)="handleScroll()"
            >
              @for (tile of tiles; track tile.title) {
              <div
                class="card-c"
                (click)="openRedeemModal(tile)"
                #cardEl
                [ngStyle]="{ 'background-image': 'url(' + tile.image + ')' }"
              >
                <div
                  class="d-flex justify-content-end"
                  [innerHTML]="tile.icon | safeHtml"
                ></div>
                <div
                  class="gb-headline4 white-text"
                  [innerHtml]="$safeNavigationMigration(tile?.title)"
                ></div>
              </div>
              }
            </div>

            <button
              class="arrow right d-none d-md-flex"
              (click)="scrollRight()"
              [disabled]="currentPage >= totalPages - 1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30px"
                viewBox="0 0 320 512"
              >
                <path
                  fill="#ffffff"
                  d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                />
              </svg>
            </button>
          </div>

          <!-- Redeem Carousel - Pagination Dots -->
          <div
            class="dots d-flex flex-md-row align-items-center justify-content-center"
          >
            <button
              class="arrow left z-1 d-flex d-md-none"
              (click)="scrollLeft()"
              [disabled]="currentPage === 0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30px"
                viewBox="0 0 320 512"
                transform="scale(-1 1)"
              >
                <path
                  fill="#ffffff"
                  d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                />
              </svg>
            </button>

            <div class="d-flex gap-10">
              @for (page of paginationArray; track $index ) {
              <span
                class="dot"
                [class.active]="$index === currentPage"
                (click)="goToPage($index)"
              >
              </span>
              }
            </div>

            <button
              class="arrow d-flex d-md-none"
              (click)="scrollRight()"
              [disabled]="currentPage >= totalPages - 1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30px"
                viewBox="0 0 320 512"
              >
                <path
                  fill="#ffffff"
                  d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="container mb-63">
      <div class="d-flex row justify-content-center px-md-5 gap-24">
        <div
          class="col-md-4 text-md-start gm-family-title"
          [innerHtml]="signOnPage?.marketingPage.gmFamily.gmFamilyTitle"
        ></div>
        <div
          class="col-md text-md-start gm-family"
          [innerHtml]="signOnPage?.marketingPage.gmFamily.gmFamilyBody"
        ></div>
      </div>
    </div>
  </div>
</section>
}

<app-modal
  [(visible)]="showRedeemModal"
  [showHeader]="false"
  [modalSize]="'modal-lg'"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-body">
      <div
        class="gb-headline4"
        [innerHtml]="$safeNavigationMigration(currentTile?.title)"
      ></div>
    </div>
    <div class="gb-body1">
      <div [innerHtml]="$safeNavigationMigration(currentTile?.body)"></div>
    </div>
    <div class="gb-body3 lh-14">
      <div
        [innerHtml]="$safeNavigationMigration(currentTile?.disclaimer)"
      ></div>
    </div>
  </div>
</app-modal>
